/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { requestResetValidation } from 'validation/auth.validation';
import MobileContext from 'context/MobileContext';
import SignUpLayout from 'layouts/SignUpLayoutNew';
import Text from 'components/shared/Text';
import history from 'store/history';
import styles from './style.module.css';
import CustomTextField from '../CustomComponents/TextField';
import CustomButton from '../CustomComponents/Button';

const ResetPassword = ({ requestReset, isRequesting, requestType, error }) => {
  const [showError, setShowError] = useState(false);
  const isMobile = useContext(MobileContext);
  const mobClassName = isMobile ? styles.mob : '';

  useEffect(() => {
    if (requestType === 'REQUEST_RESET_FAILURE' && error) {
      setShowError(true);
    }
  }, [requestType, error]);


  const handleBackClick = () => {
    history.push('/login');
  };

  return (
    <SignUpLayout
      width={isMobile ? '100%' : '550px'}
      height={isMobile ? '100%' : '450px'}
      isMobile={isMobile}
      headerName={'Forgot Password'}
    >
      <div className={styles.page}>
        <Text tag="p" type="p2" className={`${styles.paragraph} ${mobClassName}`}>
          Enter the email address that&apos;s associated <br /> with your
          <strong className={`${styles.bold} ${mobClassName}`}>
            {' '}
            FITNESS SF account.
          </strong>
        </Text>

        <Text tag="p" type="p2" className={`${styles.p2} ${mobClassName}`}>
          We will send you a password reset link.
        </Text>

        <Formik
          initialValues={{ email: '' }}
          validationSchema={requestResetValidation}
          onSubmit={({ email }) => {
            requestReset(email?.toLowerCase());
          }}
        >
          {({
            handleSubmit,
            values,
            errors,
            touched,
            dirty,
            isValid,
            handleBlur,
            handleChange,
          }) => (
            <form className={styles.form} onSubmit={handleSubmit}>
              <CustomTextField
                onChange={e => {
                  setShowError(false);
                  handleChange(e);
                }}
                value={values.email}
                invalid={showError ? true : touched.email && Boolean(errors.email)}
                error={showError ? error : errors.email}
                name="email"
                placeholder="Email address"
                disabled={isRequesting}
                onBlur={handleBlur}
                marginTop={isMobile ? '20px' : '40px'}
              />
              <CustomButton
                type="submit"
                isRequesting={isRequesting}
                disabled={!(isValid && dirty) || isRequesting}
                className={`${styles.button} ${isMobile ? styles.mob : ''}`}
              >
                Request Reset Link
              </CustomButton>
            </form>
          )}
        </Formik>
        <p
          className={`${styles.link} ${!isMobile ? styles.mob : null}`}
          onClick={() => handleBackClick()}
        >
          Cancel
        </p>
      </div>
    </SignUpLayout>
  );
};

ResetPassword.propTypes = {
  requestReset: PropTypes.func.isRequired,
  isRequesting: PropTypes.bool,
  error: PropTypes.string,
  requestType: PropTypes.string,
};

ResetPassword.defaultProps = {
  isRequesting: false,
  error: '',
  requestType: '',
};

ResetPassword.defaultProps = {};

export default ResetPassword;
